import { Component, OnInit, Input } from '@angular/core';
import { PartnerRelationship } from '../../models/PartnerRelationship';
import { Partner, PartnerUserDataGroup } from '../../models/partner';
import { GlobalNamespace as _GlobalNS } from '../../../../environments/environment';
import { GlobalService } from '../../../core/global.service';
import { PartnerUser, Privilege, PrivilegeGroup } from '../../models';
import { Subscription } from 'rxjs';
import { PartnerUserService } from '../../partner-user.service';
import { Message, ConfirmationService } from 'primeng/api';
import { cloneDeep as clone } from 'lodash';
import { disableDebugTools } from '@angular/platform-browser';

@Component({
  selector: 'app-partner-user-list',
  templateUrl: './partner-user-list.component.html',
  styleUrls: ['./partner-user-list.component.scss'],
  providers: [ConfirmationService]
})
export class PartnerUserListComponent implements OnInit {
  displayAddDialog = false;
  displayEditDialog = false;
  partnerData: Partner;
  currentPartner: Partner;
  @Input() partnership: PartnerRelationship;
  partnerUserList: Partner[];
  assetGroupItemId = [];
  canAddPartnerUser: boolean;
  subscription: Subscription;
  partnerUserDataGroup: PartnerUserDataGroup[];
  loading = false;
  messages: Message[] = [];
  displayInactivateDialog = false;

  constructor(private _global: GlobalService, private partnerUserSvc: PartnerUserService,
    private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.loading = true;
    this.partnership.MasterDataKeys.map((group, index) => {
      this.assetGroupItemId.push(group.ItemId);
    });
    this.subscription = this.partnerUserSvc.find()
      .subscribe((partnerUser: PartnerUserDataGroup[]) => {
          this.partnerUserDataGroup = (<any>partnerUser).data;
          this.loading = false;
    });
    this.populatePartnerData();
    this.canAddPartnerUser = this._global.find((<any>_GlobalNS).paths.PartnerUserPriv);
  }

  populatePartnerData(): void {
    const data = {
      'RelationshipXrefId': this.partnership.RelationshipId,
       'CompanyName': this.partnership.ChildCompany.Name,
       'RelationshipType': this.partnership.RelationshipType.Description,
       'AssetGroupList': this.assetGroupItemId.join(', '),
       'Privileges': this.partnership.Privileges,
       'PrivilegeGroups': this.partnership.PrivilegeGroups
     };
     this.partnerData = <Partner>data;
  }

  partnerUser(message: string) {
    this.loading = true;
    this.messages = [{severity: 'info', summary: 'Processing..', detail: ''}];
    this.subscription = this.partnerUserSvc.find()
      .subscribe((partnerUser: PartnerUserDataGroup[]) => {
          this.partnerUserDataGroup = (<any>partnerUser).data;
          this.messages = [{severity: 'success', summary: message, detail: ''}];
          this.loading = false;
      }, error => {
        this.errorMessage('Error Occcured while Processing');
        this.loading = false;
      });
  }

  editPartnerUser(partner: Partner): void {
    this.currentPartner = clone(partner);
    this.displayEditDialog = true;
  }

  newPartnerUser(partner: Partner) {
    this.partnerUser('Partner User Successfully Added');
  }

  updatePartnerUser(partner: Partner) {
    this.partnerUser('Partner User Successfully Updated');
  }

  showAddDialog(): void {
    this.displayAddDialog = true;
  }

  addDialogClose(display: boolean): void {
    this.displayAddDialog = display;
  }

  showEditDialog(): void {
    this.displayEditDialog = true;
  }

  editDialogClose(display: boolean): void {
    this.displayEditDialog = display;
    this.displayInactivateDialog = display;
  }

  errorMessage(message: string) {
    this.messages = [{severity: 'error', summary: message, detail: ''}];
  }

  assetGroupList(partnerUser: PartnerUserDataGroup): string {
    let aData = [];
      for (let i = 0, group = partnerUser.RelationshipDataGroup; i < group.length; i++) {
        if (group[i].IsMasterList) {
          aData = [];
          aData.push(group[i].RelationshipGroupName);
          break;
        } else {
          aData.push(group[i].Items.map((item) => item.ItemId).join(', '));
        }
      }
    return aData.join(', ');
  }
  deactivateUserConfirm(RelationshipXrefId: any, partnerUser: PartnerUser, partner?: Partner): void {
    if (partnerUser.IsPrimary) {
      this.inactivateParnerUser(partner);
    } else {
      const message = `Are you sure you want to Inactivate this user from your
                      relationship and remove their access to your loans/properties?`;
      this.confirmationService.confirm({
          message: message,
          accept: () => {
            this.loading = true;
            this.messages = [{severity: 'info', summary: 'Processing Inactivation', detail: ''}];
            // Set the isActive attribute as false to inactivate a partner user and send the whole object.
            partnerUser.Person.IsActive = false;
            this.deactivateUser(RelationshipXrefId, partnerUser);
          }
      });
    }
  }

  deactivateUser(RelationshipXrefId: any, partnerUser: PartnerUser): void {
    this.subscription = this.partnerUserSvc.deactivateUser(RelationshipXrefId, partnerUser)
      .subscribe(partners  => {
      this.partnerUserList = partners['data'];
      this.populatePartnerData();
      this.loading = false;
      this.messages = [{severity: 'info', summary: 'Inactivated: ', detail: `Successfully Inactivated
                        User: ${partnerUser.Person.Email}`}];
    });
  }

  privilegeList(privileges: Privilege[]): string {
    const aData: any = [];
    if (privileges !== undefined && privileges.length) {
      privileges.filter((privilegeFilter: Privilege) => privilegeFilter.Enabled)
        .map((privilegeMap: Privilege) => aData.push(privilegeMap.PrivilegeName));
    }
    return aData.join(', ');
  }

   /* display Inactivate partner user popup */
  inactivateParnerUser(partner: Partner): void {
    this.currentPartner = clone(partner);
    this.displayInactivateDialog = true;
  }

}
